module.exports = __webpack_public_path__ + "img/profile-img.bb5e89cd.png";